export class AuditProcessDefInfo {
    auditId: AuditEvent;
    success: boolean;
    processDefKey: string;
}

export enum AuditEvent {
    WF_ProcessDef_SaveDT = 'WF_ProcessDef_SaveDT',
    WF_ProcessDef_SaveRT = 'WF_ProcessDef_SaveRT',
    WF_ProcessDef_Deploy = 'WF_ProcessDef_Deploy',
    WF_ProcessDef_Import = 'WF_ProcessDef_Import',
    WF_ProcessDef_Export = 'WF_ProcessDef_Export',
    WF_ProcessDef_SyncDT = 'WF_ProcessDef_SyncDT'
}
